import React from 'react';

interface PlayIconProps {
  /**
   * Icon color, defaults to currentColor
   */
  fill?: string;
  /**
   * Icon width
   */
  width?: number;
  /**
   * Icon height
   */
  height?: number;
  /**
   * CSS className
   */
  className?: string;
}

export const PlayIcon: React.FC<PlayIconProps> = ({
  fill = '#ffffff',
  width = 48,
  height = 48,
  className = '',
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      fill="none"
      viewBox="0 0 48 48"
      role="img"
    >
      <title>Play Icon</title>
      <path d="M16 12v24l20-12z" fill={fill} />
    </svg>
  );
};

export default PlayIcon;
